import Preloader from '../dooh-react-utils/preload/Preloader';

export const items = [
  require('./pic0.png'),
  require('./pic1.png'),
  require('./pic2.png'),
  require('./pic3.png'),
  require('./pic4.png'),
  require('./pic5.png'),
  require('./pic5.png'),
];

export const preloader = new Preloader(
  items.concat([
    require('./bg.png'),
    require('./cta.png'),
    require('./game.png'),
    require('./result.png'),
    require('./toplist.png'),
    require('./krug.png'),
    require('./mark.png'),
  ]),
  [
    { name: 'regularfont', url: require('./ZonaPro-Regular.woff') },
    { name: 'boldfont', url: require('./ZonaPro-Bold.woff') },
    { name: 'blackfont', url: require('./ZonaPro-Black.woff') },
  ]
);
